// Person categories for the "By Person" stacked breakdown — mirrors the same
// dummy identities used for "Completed By" on the Completed AI Tasks table
// (see CompletedTasksTable.jsx DUMMY_COMPLETED_BY), so the two mock views stay
// consistent. Colors are a qualitative categorical palette, distinct from the
// task-type/model-tier palettes since this is a separate breakdown dimension.
export const PERSON_TYPES = [
  { key: "admin@esg360.io", label: "admin@esg360.io", color: "#EC4899" },
  { key: "hannah@esg360.io", label: "hannah@esg360.io", color: "#0891B2" },
];

export const PERSON_TYPE_KEYS = PERSON_TYPES.map((t) => t.key);

export function getPersonColor(key) {
  return PERSON_TYPES.find((t) => t.key === key)?.color || "#A0AEC0";
}
